import React, { useCallback } from "react"
import { downloadFile } from "../../helpers/download"
import { useCopyFeedback } from "../../hooks"

export const MAX_CHOICES = 100

export const limitChoices = (text, maxChoices = MAX_CHOICES) => {
  const lines = text.split("\n")
  const limited = []
  let count = 0

  for (const line of lines) {
    const isEmpty = line.trim() === ""
    if (isEmpty || count < maxChoices) {
      limited.push(line)
      if (!isEmpty) count++
    }
  }

  return limited.join("\n")
}

const ChoicesInput = ({ value, onChange }) => {
  const hasContent = value.trim().length > 0

  const copyValue = useCallback(() => navigator.clipboard.writeText(value), [value])
  const [copyFeedback, copyToClipboard] = useCopyFeedback(copyValue)

  const saveAsTxt = () => {
    if (!hasContent) return
    downloadFile(value, "spin-wheel-choices.txt")
  }

  return (
    <>
      <textarea
        name="choices"
        className="input-base choices-input"
        rows="5"
        placeholder="Manually enter the choices - enter one choice per line..."
        value={value}
        onChange={(e) => onChange(limitChoices(e.target.value))}
      />
      <div className="choices-input-actions">
        <button
          className="btn-base btn-secondary choices-input-btn"
          onClick={() => onChange("")}
          disabled={!hasContent}
          title="Clear all choices"
        >
          Clear
        </button>
        <button
          className="btn-base btn-secondary choices-input-btn"
          onClick={copyToClipboard}
          disabled={!hasContent}
          title="Copy choices to clipboard"
        >
          {copyFeedback ? "Copied!" : "Copy"}
        </button>
        <button
          className="btn-base btn-secondary choices-input-btn"
          onClick={saveAsTxt}
          disabled={!hasContent}
          title="Download choices as text file"
        >
          Save
        </button>
      </div>
    </>
  )
}

export default ChoicesInput
